import { Globals } from "./constants";
import { MessageFactory } from "./messages";
import { Protocol } from "./constants";
import { logger } from "../App";
import { objToStringSettings } from "../components/otherPages/settings/saveSettings/objToString/objToStringSettings";

export const placeBet = (bet, selected) => {
  if (!Globals.WS) {
    return console.error("SOCKET DOESN'T EXISTS, Globals.WS - " + Globals.WS);
  }
  Globals.WS.sendMessage(
    MessageFactory.createMessage(Protocol.BET, +bet, selected)
  );
};

export const requestBetReplay = (id) => {
  logger.log(id);
  const getRound = MessageFactory.createMessage(Protocol.GET_ROUND, id);
  Globals.WS.sendMessage(getRound);
};

export const sendSettings = (obj, min, max) => {
  const stringifiedObject = objToStringSettings(obj, min, max);
  logger.log("Protocol.USER_SETTINGS stringified", stringifiedObject);
  const settings = MessageFactory.createMessage(
    Protocol.USER_SETTINGS,
    stringifiedObject
  );
  if (!Globals.WS) {
    return console.error("SOCKET DOESN'T EXISTS, Globals.WS - " + Globals.WS);
  }
  Globals.WS.sendMessage(settings);
};
